// extracted by mini-css-extract-plugin
export default {"label":"LinkDetailsContainer-label-5ae276a9674597ca833328ddc66d6a93","buttonContainer":"LinkDetailsContainer-buttonContainer-5ef7b8dd27561bcf97f5470da856f134"};